export const title = "FLOTA";
export const priceText = "Precio por día: ";
